// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_NOOXZ {
    background: #FFFFFF;
    border: 1px solid var( --color-base100 );
    border-radius: 8px;
    padding: 12px;
}
.nameValueContainer_scUnx {
    flex: 1 !important;
    overflow: hidden !important;
}
.body_uDYCG {
    font-style: normal !important;
    font-weight: 400 !important;
    font-size: 15px !important;
    line-height: 24px !important;
    color: var( --color-base700 ) !important;
}
.name_e44cM {
    font-style: normal !important;
    font-weight: 400 !important;
    font-size: 15px !important;
    line-height: 24px !important;
    color: var( --color-base700 ) !important;
}
.value_QPewn {
    font-style: normal !important;
    font-weight: 600 !important;
    font-size: 15px !important;
    line-height: 24px !important;
    color: var( --color-base800 ) !important;
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/actions/salesFlow/AddAdditionalTags.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,wCAAwC;IACxC,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,2BAA2B;AAC/B;AACA;IACI,6BAA6B;IAC7B,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,wCAAwC;AAC5C;AACA;IACI,6BAA6B;IAC7B,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,wCAAwC;AAC5C;AACA;IACI,6BAA6B;IAC7B,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,wCAAwC;AAC5C","sourcesContent":[".container {\n    background: #FFFFFF;\n    border: 1px solid var( --color-base100 );\n    border-radius: 8px;\n    padding: 12px;\n}\n.nameValueContainer {\n    flex: 1 !important;\n    overflow: hidden !important;\n}\n.body {\n    font-style: normal !important;\n    font-weight: 400 !important;\n    font-size: 15px !important;\n    line-height: 24px !important;\n    color: var( --color-base700 ) !important;\n}\n.name {\n    font-style: normal !important;\n    font-weight: 400 !important;\n    font-size: 15px !important;\n    line-height: 24px !important;\n    color: var( --color-base700 ) !important;\n}\n.value {\n    font-style: normal !important;\n    font-weight: 600 !important;\n    font-size: 15px !important;\n    line-height: 24px !important;\n    color: var( --color-base800 ) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_NOOXZ`,
	"nameValueContainer": `nameValueContainer_scUnx`,
	"body": `body_uDYCG`,
	"name": `name_e44cM`,
	"value": `value_QPewn`
};
export default ___CSS_LOADER_EXPORT___;
